<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="会员中心-设置会员折扣"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="right-body">
                <el-tabs v-model="tabName" type="card">
                    <el-tab-pane label="项目" name="product">
                        <!--所有项目优惠-->
                        <product-all-discount :pro-type="productType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--项目分类优惠-->
                        <product-category-discount :pro-type="productType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--项目分类优惠-->
                        <product-one-discount :pro-type="productType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                    </el-tab-pane>
                    <el-tab-pane label="卡项" name="card">
                        <!--所有卡项优惠-->
                        <product-all-discount :pro-type="cardType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--商品卡项优惠-->
                        <product-category-discount :pro-type="cardType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--商品卡项优惠-->
                        <product-one-discount :pro-type="cardType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                    </el-tab-pane>
                    <el-tab-pane label="产品" name="goods">
                        <!--所有商品优惠-->
                        <product-all-discount :pro-type="goodsType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--商品分类优惠-->
                        <product-category-discount :pro-type="goodsType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                        <!--商品单独优惠-->
                        <product-one-discount :pro-type="goodsType" />
                        <div class="blank10"></div>
                        <div class="blank10"></div>
                        <div class="blank10"></div>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div class="layout-right-bottom">
            <!--右下-->
        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import obj from "@/js/obj";
    import SelectCategory from "@/model/StoreUser/SelectCategory";
    import ProductCategoryDiscount from "@/model/StoreUser/ProductCategoryDiscount";
    import ProductAllDiscount from "@/model/StoreUser/ProductAllDiscount";
    import ProductOneDiscount from "@/model/StoreUser/ProductOneDiscount";
    export default {
        name: "VipDiscount",
        components: {
            ProductOneDiscount, ProductAllDiscount, ProductCategoryDiscount, SelectCategory, RightTop},
        data: () => ({
            tabName: "product",
            proDisData: [],             //项目优惠

            productType: 1,
            goodsType: 0,
            cardType: 0,
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "5-1");

        },
        methods: {

        },
        watch: {
            tabName: function (val) {
                switch (val) {
                    case "product":
                        this.productType = 1;
                        break;
                    case "goods":
                        this.goodsType = 2;
                        break;
                    case "card":
                        this.cardType = 5;
                        break;
                    default:
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .right-body{
        background: #fff;
        padding: 16px;
    }
</style>

